import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaBook,
  FaUser,
  FaEnvelope,
  FaYoutube,
  FaTiktok,
  FaInstagram,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "./Sidebar.css";

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
        <nav className="nav-links">
          <Link to="/" className="nav-item" onClick={toggleSidebar}><FaHome /> Home</Link>
          <Link to="/recipes" className="nav-item" onClick={toggleSidebar}><FaBook /> Recipes</Link>
          <Link to="/about" className="nav-item" onClick={toggleSidebar}><FaUser /> About</Link>
          <Link to="/contact" className="nav-item" onClick={toggleSidebar}><FaEnvelope /> Contact</Link>
        </nav>
        <div className="social-links">
          <a href="https://www.youtube.com/@whatsriacookin" target="_blank" rel="noreferrer"><FaYoutube /></a>
          <a href="https://www.tiktok.com/@whatsriacookin" target="_blank" rel="noreferrer"><FaTiktok /></a>
          <a href="https://www.instagram.com/whatsriacookin" target="_blank" rel="noreferrer"><FaInstagram /></a>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
